import { LayoutDashboard, Building2, Users, TrendingUp, DollarSign, CreditCard, Settings2, MoreHorizontal, BarChart3, Footprints, Brain } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const mainItems = [
  { title: "Overview", url: "/", icon: LayoutDashboard },
  { title: "Businesses", url: "/admin/businesses", icon: Building2 },
  { title: "Users", url: "/admin/users", icon: Users },
  { title: "Subscriptions", url: "/admin/subscriptions", icon: CreditCard },
];

const moreItems = [
  { title: "Finance", url: "/admin/finance", icon: DollarSign },
  { title: "Insights", url: "/admin/alerts", icon: TrendingUp },
  { title: "Usage", url: "/admin/usage", icon: BarChart3 },
  { title: "Activation", url: "/admin/activation", icon: Footprints },
  { title: "Behavior", url: "/admin/behavior", icon: Brain },
  { title: "System", url: "/admin/system", icon: Settings2 },
];

export function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isMoreActive = moreItems.some((item) => location.pathname === item.url);

  return (
    <>
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-around border-t bg-card/95 backdrop-blur-md safe-bottom md:hidden"
        role="navigation"
        aria-label="Main navigation"
      >
        {mainItems.map((item) => (
          <NavLink
            key={item.url}
            to={item.url}
            end={item.url === "/"}
            className="flex flex-col items-center gap-0.5 px-2 py-2.5 min-w-[48px] min-h-[48px] justify-center text-muted-foreground transition-colors"
            activeClassName="text-brand"
            aria-label={item.title}
          >
            <item.icon className="h-5 w-5" />
            <span className="text-[10px] font-medium leading-tight">{item.title}</span>
          </NavLink>
        ))}
        <button
          onClick={() => setMoreOpen(true)}
          className={`flex flex-col items-center gap-0.5 px-2 py-2.5 min-w-[48px] min-h-[48px] justify-center transition-colors ${isMoreActive ? "text-brand" : "text-muted-foreground"}`}
          aria-label="More"
        >
          <MoreHorizontal className="h-5 w-5" />
          <span className="text-[10px] font-medium leading-tight">More</span>
        </button>
      </nav>

      <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl px-4 pb-8 pt-4">
          <SheetTitle className="sr-only">More navigation</SheetTitle>
          <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-muted" />
          <div className="flex flex-col gap-1">
            {moreItems.map((item) => (
              <button
                key={item.url}
                onClick={() => {
                  navigate(item.url);
                  setMoreOpen(false);
                }}
                className={`flex items-center gap-3 rounded-lg px-3 py-3 text-sm font-medium transition-colors ${
                  location.pathname === item.url
                    ? "bg-accent text-brand"
                    : "text-foreground hover:bg-accent/50"
                }`}
              >
                <item.icon className="h-5 w-5" />
                <span>{item.title}</span>
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
